import * as React from "react";
import { Tag } from "@workflows/ui";
import { Trans, useTranslation } from "react-i18next";

export interface AssignedTagActivityProps {
  activity: any;
}

export function AssignedTagActivity({
  activity,
}: AssignedTagActivityProps): JSX.Element {
  const { toObject, actor, insertedAt } = activity;
  const { t } = useTranslation("ai.workflows.activities");

  return (
    <div>
      <Trans i18nKey="AssignedTagActivity" t={t}>
        {{ actorName: actor.name }} added the{" "}
        <Tag color={toObject.color} textColor={toObject.textColor} size="sm">
          {{ objectName: toObject.name }} {{ insertedAt }}
        </Tag>
        label
      </Trans>
    </div>
  );
}
